import { Texture, WebGLRenderer, Vector2, RepeatWrapping } from "three";
export function createRenderer(width, height) {
  const renderer = new WebGLRenderer({
    antialias: true,
    alpha: true
  });
  renderer.setSize(width, height);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setClearColor(0, 0);
  return renderer;
}
export function createTextureFromCanvas(canvas, repeatCount) {
  const texture = new Texture(canvas);
  texture.needsUpdate = true;
  texture.anisotropy = 4;
  if (repeatCount) {
    texture.repeat = new Vector2(repeatCount, repeatCount);
    texture.wrapS = RepeatWrapping;
    texture.wrapT = RepeatWrapping;
  }
  return texture;
}
let webGlSupportedCache = undefined;
export function WebGlSupported() {
  if (webGlSupportedCache !== undefined) {
    return webGlSupportedCache;
  }
  try {
    const canvas = document.createElement("canvas");
    webGlSupportedCache = !!(WebGLRenderingContext && (canvas.getContext("webgl") || canvas.getContext("experimental-webgl")));
  } catch (e) {
    webGlSupportedCache = false;
  }
  return webGlSupportedCache;
}